export const contactUsForm = {
  default: {
    title: {
      label: 'Send us a message',
      translationKey: 'send_us_a_msg',
    },
    twoCol: false,
    hasReCAPTCHA: false,
    reCaptcha: {
      // validations: {
      //   label: 'Please confirm',
      //   translationKey: 'valid_recaptcha',
      //   icon: <IoMdCloseCircleOutline />,
      // }
    },
    fields: [
      {
        label: 'Field Label',
        translationKey: 'name_label',
        id: 'name',
        type: 'text',
        placeholder: {
          label: 'Write something',
          translationKey: 'name_placeholder',
        },
        twoCol: true,
      },
      {
        label: 'Email Address',
        id: 'email',
        type: 'email',
        placeholder: {
          label: 'Email@placeholder.com',
          translationKey: 'email_placeholder',
        },
        translationKey: 'email_label',
        twoCol: true,
      },

      {
        label: 'Field Label',
        id: 'comment',
        type: 'textarea',
        placeholder: {
          label: 'Write something',
          translationKey: 'comment_placeholder',
        },
        translationKey: 'textarea_label',
        maxLength: '1000',
        twoCol: false,
      },
    ],
  },
};

export const newsLetterForm = {
  default: {
    title: {
      label: 'You get more than 405 free spins',
      translationKey: 'newsletter_form_main_text',
    },
    description: {
      label: '',
      translationKey: 'newsletter_form_subscribe_text',
    },
    fields: [
      {
        label: 'Name',
        id: 'name',
        type: 'text',
        translationKey: 'newsletter_form_first_name_text',
        required: true,
        placeholder: {
          label: 'John Doe',
          translationKey: 'newsletter_form_first_name_placeholder',
        },
      },
      {
        label: 'Email Address',
        id: 'email',
        type: 'email',
        translationKey: 'newsletter_form_email_text',
        required: true,
        placeholder: {
          label: 'johndoe@email.com',
          translationKey: 'newsletter_form_email_placeholder',
        },
      },
      {
        type: 'checkbox',
        id: 'checkbox',
        options: [
          {
            label: 'I confirm I am over 18 years old.',
            id: 'checkbox',
            type: 'checkbox',
            link: {
              url: 'https://google.com',
              text: 'Link',
              translationKey: 'link_checkbox',
            },
            required: true,
            translationKey: 'newsletter_form_privacy_text_1',
          },
          {
            label:
              'I agree that my contact data may be used to keep me informed about casino products, services, and offerings.',
            id: 'checkbox_2',
            type: 'checkbox',
            link: {
              url: 'https://google.com',
              text: 'Link',
              translationKey: 'link_checkbox',
            },
            required: true,
            translationKey: 'newsletter_form_privacy_text_2',
          },
          {
            label:
              'Read our [link] for more details. You can unsubscribe from receiving future marketing communication at any time.',
            id: 'checkbox_3',
            type: 'checkbox',
            link: {
              url: '/privacy-policy',
              text: 'Link',
              translationKey: 'link_checkbox',
            },
            required: false,
            translationKey: 'newsletter_form_privacy_text_3',
          },
        ],
      },
    ],
  },
  // 'ie_en': {
  //   title: {
  //     label: 'You get more than 405 free spins',
  //     translationKey: 'newsletter_mainText',
  //   },
  //   description: {
  //     label: 'Subscribe to our newsletter and get more than 405 free spins instantly.',
  //     translationKey: 'newsletter_subscribeText',
  //   },
  //   fields: [
  //     {
  //       label: 'Name',
  //       id: 'name',
  //       type: 'text',
  //       translationKey: 'newsletter_form_first_name_placeholder',
  //       required: true,
  //       placeholder: {
  //         label: 'John Doe',
  //         translationKey: 'newsletter_placeholder_name',
  //       },
  //     },
  //     {
  //       label: 'Email Address',
  //       id: 'email',
  //       type: 'email',
  //       translationKey: 'newsletter_form_email_text',
  //       required: true,
  //       placeholder: {
  //         label: 'johndoe@email.com',
  //         translationKey: 'newsletter_placeholder_email',
  //       },
  //     }
  //   ],
  // },
};

export const dynamicNewsLetterForm = (page) => ({
  default: {
    title: {
      label: 'You get more than 405 free spins',
      translationKey: `dynamic_newsletter_form_main_text`,
    },
    description: {
      label: '',
      translationKey: `dynamic_newsletter_form_subscribe_text`,
    },
    fields: [
      {
        label: 'Name',
        id: 'name',
        type: 'text',
        translationKey: `${page.path}_dynamic_newsletter_form_first_name_text`,
        required: true,
        placeholder: {
          label: 'John Doe',
          translationKey: `${page.path}_dynamic_newsletter_form_first_name_placeholder`,
        },
      },
      {
        label: 'Email Address',
        id: 'email',
        type: 'email',
        translationKey: 'dynamic_newsletter_form_email_text',
        required: true,
        placeholder: {
          label: 'johndoe@email.com',
          translationKey: `${page.path}_dynamic_newsletter_form_email_placeholder`,
        },
      },
      {
        label: 'Phone Number',
        id: 'phoneNumber',
        type: 'text',
        inputMode: 'numeric',
        required: false,
        translationKey: `${page.path}_dynamic_newsletter_form_phone_text`,
        placeholder: {
          label: '08XXXXXXXX',
          translationKey: `${page.path}_dynamic_newsletter_form_phone_placeholder`,
        },
      },
    ],
  },
  // 'ie_en': {
  //   title: {
  //     label: 'You get more than 405 free spins',
  //     translationKey: 'newsletter_mainText',
  //   },
  //   description: {
  //     label: 'Subscribe to our newsletter and get more than 405 free spins instantly.',
  //     translationKey: 'newsletter_subscribeText',
  //   },
  //   fields: [
  //     {
  //       label: 'Name',
  //       id: 'name',
  //       type: 'text',
  //       translationKey: 'newsletter_form_first_name_placeholder',
  //       required: true,
  //       placeholder: {
  //         label: 'John Doe',
  //         translationKey: 'newsletter_placeholder_name',
  //       },
  //     },
  //     {
  //       label: 'Email Address',
  //       id: 'email',
  //       type: 'email',
  //       translationKey: 'newsletter_form_email_text',
  //       required: true,
  //       placeholder: {
  //         label: 'johndoe@email.com',
  //         translationKey: 'newsletter_placeholder_email',
  //       },
  //     }
  //   ],
  // },
});
